import type { FunctionComponent, PropsWithChildren } from 'react';

interface IAgGridTableContainerProps extends PropsWithChildren {
    show?: boolean;
    height?: number;
    padding?: number;
}

export const AgGridTableContainer: FunctionComponent<IAgGridTableContainerProps> = ({ show, height, padding, children }) => {
    if (!show) return <>{children}</>;

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                overflow: 'hidden',
                height: height,
                maxHeight: height,
                padding: `${padding}px`,
                backgroundColor: 'var(--bg-color-default-normal)',
            }}
        >
            {children}
        </div>
    );
};
